var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wy-custom-cell-sample"},[_c('div',{staticClass:"image",on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.row[_vm.column.name]))])])}
var staticRenderFns = []

export { render, staticRenderFns }